import styled from "@emotion/styled";
import { BACKGROUND_GRAY_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";
export const StyledTagComponent = styled.div`
  background-color: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  font-size: 0.875rem;
  font-weight: 400;
  justify-content: center;
  align-items: center;
  gap: 8px;

  .icon-container {
    svg {
      height: 24px;
    }
  }
`;
